export const APPLY_PATH = "/fleet-partner-application";

export const COMPANY = {
  name: "Xtreme Exotics Watersports LLC",
  short: "Xtreme Exotics",
  address1: "7901 4th St N, STE 300",
  address2: "St. Petersburg, FL 33702",
  phone: "352-791-0585",
  phoneHref: "tel:+13527910585",
  email: "sbrown@xtremeexotics.net",
  site: "https://xtremeexotics.net",
};

// Social profiles — update with the official URLs when confirmed.
export const SOCIALS = [
  { label: "Facebook", href: "https://www.facebook.com/xtremeexotics" },
  { label: "Instagram", href: "https://www.instagram.com/xtremeexotics" },
  { label: "LinkedIn", href: "https://www.linkedin.com/company/xtremeexotics" },
  { label: "YouTube", href: "https://www.youtube.com/@xtremeexotics" },
];

const img = (base, w = 1600) => `${base}&w=${w}&q=80&auto=format&fit=crop`;

const ASSETS = "https://customer-assets-jai6qajn.emergentagent.net/job_fleet-partner-hub/artifacts";

export const LOGO_URL = "/logo.png";

export const IMAGES = {
  hero: `${ASSETS}/zzj2akuq_caption.jpg`,
  jetAction: `${ASSETS}/zsj47fp2_caption%20%281%29.jpg`,
  fleetF: `${ASSETS}/bysjgcrh_2025-watersports-car-series-f-power-9563975-969033662-0-100720251219-1.webp`,
  fleetL: `${ASSETS}/rttawwqd_2025-watersports-car-series-l-power-9563978-969033665-0-100720251219-1.webp`,
  fleetR: `${ASSETS}/2tbsoraj_2025-watersports-car-series-r-power-9563980-969033667-0-100720251220-1.webp`,
  marinaNight: img(
    "https://images.unsplash.com/photo-1559638621-5bdd09d51d85?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1MTN8MHwxfHNlYXJjaHwxfHxsdXh1cnklMjB5YWNodCUyMG1hcmluYSUyMHdhdGVyZnJvbnQlMjByZXNvcnQlMjBhZXJpYWwlMjB2aWV3JTIwbmlnaHQlMjBsaWdodHN8ZW58MHx8fHwxNzg4NzkxNTA5fDA&ixlib=rb-4.1.0",
  ),
};

export const NAV_ITEMS = [
  { label: "Fleet Partner Program", hash: "program" },
  { label: "How It Works", hash: "how-it-works" },
  { label: "Revenue Opportunity", hash: "revenue" },
  { label: "Fleet", hash: "fleet" },
  { label: "Partner Requirements", hash: "requirements" },
  { label: "FAQ", hash: "faq" },
  { label: "Contact", hash: "contact" },
];

export const BENEFITS = [
  {
    title: "Xtreme Exotics Provides the Fleet",
    body: "Qualified partners receive access to a premium Jet Car without making the traditional equipment purchase.",
  },
  {
    title: "Maintenance & Fleet Support",
    body: "Xtreme Exotics coordinates maintenance standards, technical support and fleet requirements.",
  },
  {
    title: "Training & Operating Systems",
    body: "Partners receive staff training, customer check-in procedures, safety standards and operating guidance.",
  },
  {
    title: "Marketing Support",
    body: "Partners receive approved marketing assets and promotional support to introduce the Jet Car experience to their market.",
  },
];

export const STEPS = [
  {
    title: "Submit an Application",
    body: "Tell us about your waterfront location, current rental operation, staff, customer traffic and market.",
  },
  {
    title: "Complete the Qualification Review",
    body: "Xtreme Exotics reviews the location, water access, business experience, insurance readiness and potential demand.",
  },
  {
    title: "Prepare for Deployment",
    body: "Approved partners complete contracting, insurance verification, training, operational setup and booking integration.",
  },
  {
    title: "Launch the Jet Car Experience",
    body: "The partner promotes and operates the experience while Xtreme Exotics supports the fleet, maintenance standards and program performance.",
  },
];

export const ADDONS = [
  "Photo and video packages",
  "Birthday experiences",
  "Proposals and celebrations",
  "Sunset experiences",
  "Premium group packages",
  "Hotel or resort packages",
];

export const CHECKLIST = [
  "Established Jet Ski, pontoon, boat-rental or watersports operation",
  "Legal access to a suitable waterfront launch or dock",
  "Experienced operating staff",
  "Strong safety and customer-service record",
  "Appropriate business licensing",
  "Commercial insurance readiness",
  "Reliable booking and payment systems",
  "Consistent seasonal or year-round customer traffic",
  "Ability to market and operate a premium experience",
  "Willingness to follow Xtreme Exotics brand and operating standards",
];

export const WHY_POINTS = [
  { title: "No traditional Jet Car purchase", body: "Access a premium fleet asset without the conventional equipment buy-in." },
  { title: "Premium attraction for existing customers", body: "A high-visibility experience that elevates your current rental offering." },
  { title: "Performance-based revenue share", body: "Weekly settlement that scales with completed rental hours." },
  { title: "Fleet & maintenance support", body: "Coordinated maintenance standards and technical support." },
  { title: "Staff training & operating guidance", body: "Documented procedures for check-in, safety and daily operations." },
  { title: "Marketing & launch support", body: "Approved assets and promotional guidance for your market introduction." },
];

export const FLEET = [
  {
    name: "F Power",
    tag: "2025 Watersports Car Series",
    image: "fleetF",
    specs: [
      ["Passenger capacity", "To be confirmed"],
      ["Performance", "Specifications released during onboarding"],
      ["Available colors", "Red · Black · White"],
    ],
  },
  {
    name: "L Power",
    tag: "2025 Watersports Car Series",
    image: "fleetL",
    specs: [
      ["Passenger capacity", "To be confirmed"],
      ["Performance", "Specifications released during onboarding"],
      ["Available colors", "Red · Black · White"],
    ],
  },
  {
    name: "R Power",
    tag: "2025 Watersports Car Series",
    image: "fleetR",
    specs: [
      ["Passenger capacity", "To be confirmed"],
      ["Performance", "Specifications released during onboarding"],
      ["Available colors", "Red · Black · White"],
    ],
  },
];

// Markets under review — stylized coordinates on a 1000x680 viewBox.
export const MARKETS = [
  { id: "tampa", name: "Tampa / St. Petersburg, FL", x: 660, y: 585 },
  { id: "miami", name: "Miami / South Florida", x: 695, y: 645 },
  { id: "destin", name: "Destin / Emerald Coast, FL", x: 601, y: 529 },
  { id: "lanier", name: "Lake Lanier, GA", x: 639, y: 427 },
  { id: "myrtle", name: "Myrtle Beach, SC", x: 714, y: 440 },
  { id: "ozarks", name: "Lake of the Ozarks, MO", x: 506, y: 319 },
  { id: "chicago", name: "Lake Michigan / Chicago, IL", x: 584, y: 219 },
  { id: "travis", name: "Lake Travis / Austin, TX", x: 426, y: 529 },
  { id: "havasu", name: "Lake Havasu, AZ", x: 177, y: 419 },
  { id: "sandiego", name: "San Diego, CA", x: 133, y: 467 },
  { id: "tahoe", name: "Lake Tahoe, NV", x: 91, y: 294 },
  { id: "seattle", name: "Lake Washington / Seattle, WA", x: 56, y: 65 },
];

export const EXPECTATIONS = [
  "Defined onboarding process",
  "Documented training",
  "Operational standards",
  "Fleet-support procedures",
  "Marketing resources",
  "Performance reporting",
  "Clear weekly settlement calculations",
];

export const FAQS = [
  {
    q: "What is a Jet Car?",
    a: "A Jet Car is a high-performance watercraft styled like an exotic sports car and powered by marine jet propulsion. It delivers the look and presence of a supercar on the water and is operated as a premium, staff-managed rental experience.",
  },
  {
    q: "Who qualifies as a Fleet Partner?",
    a: "Established Jet Ski rental companies, pontoon and boat-rental operators, watersports businesses, resorts and waterfront marinas with legal water access, experienced staff, appropriate licensing and commercial insurance readiness.",
  },
  {
    q: "Does the partner purchase the Jet Car?",
    a: "No. Qualified partners receive access to a premium Jet Car without making the traditional equipment purchase, subject to the terms of the final Fleet Partner Agreement.",
  },
  {
    q: "How does the revenue share work?",
    a: "Settlement is calculated weekly. For 1–15 completed rental hours per Jet Car in a week, the Fleet Partner receives 40% of Net Rental Revenue and Xtreme Exotics receives 60%. At 16 or more completed hours in the same week, the split becomes 60% to the Fleet Partner and 40% to Xtreme Exotics — applied retroactively to every eligible completed hour that week. The calculation resets at the start of each new weekly settlement period.",
  },
  {
    q: "What counts as Net Rental Revenue?",
    a: "Net Rental Revenue is defined in the Fleet Partner Agreement. It generally means rental revenue actually collected for completed eligible rental hours, less items such as refunds, chargebacks, taxes and applicable fees.",
  },
  {
    q: "What happens when the location reaches 16 completed hours?",
    a: "The Fleet Partner share increases to 60% for that weekly settlement period, and the higher share applies retroactively to every eligible completed rental hour that week — not only the hours above 15.",
  },
  {
    q: "Who provides maintenance?",
    a: "Xtreme Exotics coordinates maintenance standards, technical support and fleet requirements. Day-to-day care responsibilities are documented in the Fleet Partner Agreement.",
  },
  {
    q: "Who provides the operating staff?",
    a: "The Fleet Partner provides the local operating staff. Xtreme Exotics supplies staff training, safety standards and operating guidance.",
  },
  {
    q: "Who handles customer check-in and safety?",
    a: "The Fleet Partner manages customer check-in and on-site safety, following the documented procedures, safety standards and training provided by Xtreme Exotics.",
  },
  {
    q: "What insurance is required?",
    a: "Fleet Partners must carry commercial insurance that meets program requirements. Coverage is verified during the onboarding process before any deployment.",
  },
  {
    q: "Can partners create their own add-ons?",
    a: "Yes. Fleet Partners may keep 100% of approved add-on revenue they create — such as photo packages, celebrations or sunset experiences — subject to approval and the Fleet Partner Agreement.",
  },
  {
    q: "How long is the Fleet Partner Agreement?",
    a: "Agreement terms, including duration, are defined during contracting and reviewed with each qualified applicant before deployment.",
  },
  {
    q: "How quickly are applications reviewed?",
    a: "Applications are reviewed promptly. Timing depends on application volume and the completeness of the information submitted.",
  },
  {
    q: "Is submitting an application a guarantee of approval?",
    a: "No. Submitting an application does not guarantee approval, deployment, exclusivity or any level of income. All partnerships are subject to qualification review and a final Fleet Partner Agreement.",
  },
];
